import permissions from './permissions';
import metrics from './metrics';
import localizations from './localizations';
import locales from './locales';
import isoLocales from './iso-locales';
import contentTypes from './content-types';

export default {
  permissions,
  metrics,
  localizations,
  locales,
  'iso-locales': isoLocales,
  'content-types': contentTypes,
};
